import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_cycle_checking_sample_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  sample_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_cycle_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  prev_sample_link_guid: fromDatatype.GuidDataFieldInterface;
  sampling_level: fromDatatype.IntegerDatatypeInterface;
  check_results: fromDatatype.VarcharDatatypeInterface;
  check_remarks: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  check_status: fromDatatype.VarcharDatatypeInterface;
  check_by_employee_name: fromDatatype.VarcharDatatypeInterface;
  last_viewed_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  last_viewed_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_aat_claim_cycle_checking_sample_link_RowClass implements bl_aat_claim_cycle_checking_sample_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  sample_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_cycle_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  prev_sample_link_guid: fromDatatype.GuidDataFieldInterface;
  sampling_level: fromDatatype.IntegerDatatypeInterface;
  check_results: fromDatatype.VarcharDatatypeInterface;
  check_remarks: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  check_status: fromDatatype.VarcharDatatypeInterface;
  check_by_employee_name: fromDatatype.VarcharDatatypeInterface;
  last_viewed_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  last_viewed_date: fromDatatype.TimestampTzDatatypeInterface;

}
